export type ISelectedFilterTemplateId = EDefaultFilterValues | string

export enum EDefaultFilterValues {
	NONE,
	CREATE_NEW
}